<template>
  <div class="default-table users-table">
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          v-if="permissions.users.actions.new"
          v-on="on"
          @click.prevent="newDialog()"
          color="primary"
          class="mb-9"
          app
          fab
          bottom
          right
          fixed
        >
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.users.new.title }}</span>
    </v-tooltip>
    <userView
      v-if="dialog.selected"
      :value="dialog.selected"
      :dialog="dialog.view"
      @edit="editDialog(dialog.selected)"
      @closed="onCloseView"
    />
    <userSave
      v-if="dialog.selected"
      v-model="dialog.selected"
      :id="dialog.selected.id"
      :dialog="dialog.save"
      @closed="onCloseSave"
    />
    <DataTable
      name="users"
      :items="get_data.users"
      :tablehdrs="tableheaders.users"
      :search="true"
    >
      <template v-slot:default="{ item }">
        <tr :key="item.id" @dblclick="viewUser(item)" class="table-row user-list-item">
          <td>
            <strong>{{ item.id }}</strong>
          </td>
          <td>
            {{ item.name }}
          </td>
          <td>
            {{ item.login }}
          </td>
          <td>
            <v-chip :color="item.function_color" dark>{{ item.function_name }}</v-chip>
          </td>
          <td>
            <v-chip v-if="!item.categories || item.categories.length === 0" dark>{{ lang.users.datatable.headers.all }}</v-chip>
            <v-chip v-else v-for="cat in item.categories" :key="cat.id" class="mr-1" dark>{{ cat.name }}</v-chip>
          </td>
          <td class="actionsCol">
            <Actions :user="item" @view="viewDialog(item)" @edit="editDialog(item)" />
          </td>
        </tr>
      </template>
      <template v-slot:mobile="{ item }">
        <tr :key="`mb-${item.id}`" @dblclick="viewDialog(item)" class="table-row mobile_row user-list-item">
          <td class="mobile_col">
            <ul class="flex-content pl-2">
              <li class="flex-item" :data-label="`${lang.users.datatable.headers.id}:`">{{ item.id }}</li>
              <li class="flex-item" :data-label="`${lang.users.datatable.headers.name}:`">{{ item.name }}</li>
              <li class="flex-item" :data-label="`${lang.users.datatable.headers.login}:`">{{ item.login }}</li>
              <li class="flex-item" :data-label="`${lang.users.datatable.headers.function}:`">
                <v-chip :color="item.function_color" dark>{{ item.function_name }}</v-chip>
              </li>
              <li class="flex-item" :data-label="`${lang.users.datatable.headers.category}:`">
                <v-chip v-if="!item.categories || item.categories.length === 0" dark>{{ lang.users.datatable.headers.all }}</v-chip>
                <v-chip v-else v-for="cat in item.categories" :key="cat.id" class="mr-1" dark>{{ cat.name }}</v-chip>
              </li>
              <li class="flex-item actions_row" :data-label="lang.users.datatable.headers.action">
                <Actions :user="item" @view="viewDialog(item)" @edit="editDialog(item)" />
              </li>
            </ul>
          </td>
        </tr>
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataTable from '@/templates/global/DataTable'
import Actions from './templates/Actions'
import userView from './View'
import userSave from './Save'

import defaults from '@/modules/default'
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import listDefaults from '@/mixins/defaults/list'

export default {
  components: { DataTable, Actions, userView, userSave },
  mixins: [ appdata, utils, listDefaults ],
  data: () => ({
    default: { ...defaults.blank.user }
  })
}
</script>

<style scoped src="./styles/list.scss" lang="scss"></style>
